import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import { AuthProvider } from "../components/context/AuthContext";
import AboutUs from "../components/common/AboutUs";
import CartPage from "../components/common/cartpage/CartPage";
import MainLayout from "../layout/MainLayout";
import PaymentPage from "../components/common/paymentpage/PaymentPage";
import OrderConfirmation from "../components/common/OderConfirmation";
import ShopPage from "../components/common/ShopPage";
import ProductPage from "../components/common/productpage/ProductPage";
import Mentop from "../components/common/mens/mendropdown/Mentop";
import MenPolo from "../components/common/mens/mendropdown/MenPolo";
import MenSleeveless from "../components/common/mens/mendropdown/MenSleeveless";
import MenLongSleeve from "../components/common/mens/mendropdown/MenLongSleeve";
import MenJacketHoodies from "../components/common/mens/mendropdown/MenJacket&Hoodies";
import MenShorts from "../components/common/mens/mendropdown/MenShorts";
import MenPantsLeggines from "../components/common/mens/mendropdown/MenPants&Leggings";
import MenTracksuits from "../components/common/mens/mendropdown/MenTracksuits";
import MenCricket from "../components/common/mens/mendropdown/MenCricket";
import MenFootball from "../components/common/mens/mendropdown/MenFootball";
import MenShooting from "../components/common/mens/mendropdown/MenShooting";
import MenTraining from "../components/common/mens/mendropdown/MenTraining";
import MenRunning from "../components/common/mens/mendropdown/MenRunning";
import MenIndiaMerchandise from "../components/common/mens/mendropdown/MenIndiaMerchandise";
import MenShopOutlet from "../components/common/mens/mendropdown/MenShopOutlet";
import MenBagsDuffels from "../components/common/mens/mendropdown/MenBagsDuffels";
import MenHatCap from "../components/common/mens/mendropdown/MenHats&Caps";
import MenSocks from "../components/common/mens/mendropdown/MenSocks";
import MenSupporter from "../components/common/mens/mendropdown/MenSupporters";
import MenBaselayers from "../components/common/mens/mendropdown/MenCompressions&Baselayers";
import MenShoes from "../components/common/mens/mendropdown/MenShoes";
import Womentop from "../components/common/womens/womendropdown/WomenTop";
import WomenPolo from "../components/common/womens/womendropdown/WomenPolo";
import WomenSleeveless from "../components/common/womens/womendropdown/WomenSleeveless";
import WomenLongSleeve from "../components/common/womens/womendropdown/WomenLongSleeves";
import WomenJacketHoodies from "../components/common/womens/womendropdown/WomenJackets&Hoodies";
import WomenShortsSkirts from "../components/common/womens/womendropdown/WomenShorts&Skirts";
import WomenPantsLeggines from "../components/common/womens/womendropdown/WomenPants&Leggings";
import WomenTracksuits from "../components/common/womens/womendropdown/WomenTracksuits";
import WomenShooting from "../components/common/womens/womendropdown/WomenShooting";
import WomenTraining from "../components/common/womens/womendropdown/WomenTraining";
import WomenRunning from "../components/common/womens/womendropdown/WomenRunning";
import WomenIndiaMerchandise from "../components/common/womens/womendropdown/WomenIndiaMerchandise";
import WomenShopOutlets from "../components/common/womens/womendropdown/WomenShopOutlet";
import WomenBag from "../components/common/womens/womendropdown/WomenBags&Duffels";
import CricketHelmets from "../components/common/cricket/cricketdropdown/CricketHelmets";
import Clothing from "../components/common/cricket/cricketdropdown/Clothing";
import CricketBall from "../components/common/cricket/cricketdropdown/CricketBalls";
import BagDuffles from "../components/common/cricket/cricketdropdown/Bags&Duffles";
import Accessories from "../components/common/cricket/cricketdropdown/Accessories";
import Shoes from "../components/common/cricket/cricketdropdown/Shoes";
import ShopOutlets from "../components/common/cricket/cricketdropdown/ShopOutlet";
import BagsDuffles from "../components/common/Accessories/accessories drop down/Bags&Duffles";
import HatCap from "../components/common/Accessories/accessories drop down/Hats&Caps";
import Socks from "../components/common/Accessories/accessories drop down/Socks";
import Supporter from "../components/common/Accessories/accessories drop down/Supporters";
import Baselayers from "../components/common/Accessories/accessories drop down/Compressions&Baselayers";
import AccessoriesShoes from "../components/common/Accessories/accessories drop down/Shoes";
import FormRollers from "../components/common/Accessories/accessories drop down/FoamRollers";
import LoopBands from "../components/common/Accessories/accessories drop down/LoopBands";
import AccessoriesShopOutlets from "../components/common/Accessories/accessories drop down/ShopOutlet";
import LoginPage from "../pages/auth/LoginPage";
import SignupPage from "../pages/auth/SignupPage";
import ForgotPasswordPage from "../pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import Men from "../components/common/mens/mendropdown/Men";
import Women from "../components/common/womens/womendropdown/Women";
import Cricket from "../components/common/cricket/cricketdropdown/Cricket";
import AAccessories from "../components/common/Accessories/accessories drop down/Accessories";
import ProfilePage from "../pages/auth/ProfilePage";
import CartDrawer from "../components/common/cartpage/CartDrawer";
import PaymentFailure from "../components/common/paymentpage/PaymentFailure";
import PaymentSuccess from "../components/common/paymentpage/PaymentSuccess";
import CustomerDashboard from "../components/common/customer/CustomerDashboard";
import UserProfile from "../components/common/customer/UserProfile";
import OrdersPage from "../components/common/customer/CustomerOrder";
import KitBuilder from "../pages/KitBuilder";
import PrivacyPolicy from "../components/common/PrivacyPolicy";
import DeliveryReturnPolicy from "../components/common/DeliveryReturnPolicy";
import TermsAndConditions from "../components/common/TermsAndCondition";
import FrequentlyAskedQuestions from "../components/common/FrequentlyAskedQuestions";
import Catalogue from "../components/common/Catalogue";
import ContactUs from "../components/common/ContactUs";
import FabricGuide from "../components/common/FabricGuide";
import BlogDetail from "../components/common/blog/Blog";
import BlogPage from "../components/common/blog/AllBlog";
import NewArrivals from "../components/common/newarrival/NewArrivals";
import SizeChart from "../components/common/SizeChart";
import DealersPage from "../components/common/DealersPage";
import ProudPartners from "../components/common/ProudPartners";
import OurStores from "../components/common/OurStore";
import AuthDealers from "../components/common/AuthDealers";

export default function AppRoutes({
  openCart,
  cartItems,
  handleRemoveItem,
  handleIncreaseQuantity,
  handleDecreaseQuantity,
}) {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/auth/forgotpassword" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/profile" element={<ProfilePage />} />

          <Route
            path="/"
            element={
              <MainLayout openCart={openCart}>
                <Home />
              </MainLayout>
            }
          />
          <Route
            path="/about"
            element={
              <MainLayout openCart={openCart}>
                <AboutUs />
              </MainLayout>
            }
          />
          <Route
            path="/privacypolicy"
            element={
              <MainLayout openCart={openCart}>
                <PrivacyPolicy />
              </MainLayout>
            }
          />
          <Route
            path="/deliveryreturnpolicy"
            element={
              <MainLayout openCart={openCart}>
                <DeliveryReturnPolicy />
              </MainLayout>
            }
          />
          <Route
            path="/termsandconditions"
            element={
              <MainLayout openCart={openCart}>
                <TermsAndConditions />
              </MainLayout>
            }
          />
          <Route
            path="/frequently-asked-questions"
            element={
              <MainLayout openCart={openCart}>
                <FrequentlyAskedQuestions />
              </MainLayout>
            }
          />
          <Route
            path="/catalogue"
            element={
              <MainLayout openCart={openCart}>
                <Catalogue />
              </MainLayout>
            }
          />
          <Route
            path="/contact"
            element={
              <MainLayout openCart={openCart}>
                <ContactUs />
              </MainLayout>
            }
          />
          <Route
            path="/fabricguide"
            element={
              <MainLayout openCart={openCart}>
                <FabricGuide />
              </MainLayout>
            }
          />
          <Route
            path="/dealers"
            element={
              <MainLayout openCart={openCart}>
                <DealersPage />
              </MainLayout>
            }
          />
          <Route
            path="/proudpartners"
            element={
              <MainLayout openCart={openCart}>
                <ProudPartners />
              </MainLayout>
            }
          />
          <Route
            path="/ourstores"
            element={
              <MainLayout openCart={openCart}>
                <OurStores />
              </MainLayout>
            }
          />
          <Route
            path="/authdealers"
            element={
              <MainLayout openCart={openCart}>
                <AuthDealers />
              </MainLayout>
            }
          />
          <Route
            path="/cart"
            element={
              <MainLayout openCart={openCart}>
                <CartPage
                  cartItems={cartItems}
                  handleRemoveItem={handleRemoveItem}
                  handleIncreaseQuantity={handleIncreaseQuantity}
                  handleDecreaseQuantity={handleDecreaseQuantity}
                />
              </MainLayout>
            }
          />
          <Route
            path="/addcart"
            element={
              <MainLayout openCart={openCart}>
                <CartDrawer
                  cartItems={cartItems}
                  handleRemoveItem={handleRemoveItem}
                  handleIncreaseQuantity={handleIncreaseQuantity}
                  handleDecreaseQuantity={handleDecreaseQuantity}
                />
              </MainLayout>
            }
          />
          <Route
            path="/payment"
            element={
              <MainLayout openCart={openCart}>
                <PaymentPage />
              </MainLayout>
            }
          />
          <Route
            path="/orderplaced"
            element={
              <MainLayout openCart={openCart}>
                <OrderConfirmation />
              </MainLayout>
            }
          />
          <Route
            path="/shop"
            element={
              <MainLayout openCart={openCart}>
                <ShopPage />
              </MainLayout>
            }
          />
          <Route
            path="/:slug"
            element={
              <MainLayout openCart={openCart}>
                <ProductPage />
              </MainLayout>
            }
          />
          {/*Men section*/}
          <Route
            path="/men"
            element={
              <MainLayout openCart={openCart}>
                <Men />
              </MainLayout>
            }
          />
          <Route
            path="/post/:slug"
            element={
              <MainLayout openCart={openCart}>
                <Mentop />
              </MainLayout>
            }
          />
          <Route
            path="/:slug/:slug"
            element={
              <MainLayout openCart={openCart}>
                <Mentop />
              </MainLayout>
            }
          />
          <Route
            path="/category/:slug/products"
            element={
              <MainLayout openCart={openCart}>
                <Mentop />
              </MainLayout>
            }
          />
          <Route
            path="/menpolo"
            element={
              <MainLayout openCart={openCart}>
                <MenPolo />
              </MainLayout>
            }
          />
          <Route
            path="/mensleeveless"
            element={
              <MainLayout openCart={openCart}>
                <MenSleeveless />
              </MainLayout>
            }
          />
          <Route
            path="/menlongsleeveless"
            element={
              <MainLayout openCart={openCart}>
                <MenLongSleeve />
              </MainLayout>
            }
          />
          <Route
            path="/menjacket&hoodies"
            element={
              <MainLayout openCart={openCart}>
                <MenJacketHoodies />
              </MainLayout>
            }
          />
          <Route
            path="/menshorts"
            element={
              <MainLayout openCart={openCart}>
                <MenShorts />
              </MainLayout>
            }
          />
          <Route
            path="/menpants&leggings"
            element={
              <MainLayout openCart={openCart}>
                <MenPantsLeggines />
              </MainLayout>
            }
          />
          <Route
            path="/mentracksuits"
            element={
              <MainLayout openCart={openCart}>
                <MenTracksuits />
              </MainLayout>
            }
          />
          <Route
            path="/mencricket"
            element={
              <MainLayout openCart={openCart}>
                <MenCricket />
              </MainLayout>
            }
          />
          <Route
            path="/menfootball"
            element={
              <MainLayout openCart={openCart}>
                <MenFootball />
              </MainLayout>
            }
          />
          <Route
            path="/menshooting"
            element={
              <MainLayout openCart={openCart}>
                <MenShooting />
              </MainLayout>
            }
          />
          <Route
            path="/mentraining"
            element={
              <MainLayout openCart={openCart}>
                <MenTraining />
              </MainLayout>
            }
          />
          <Route
            path="/menrunning"
            element={
              <MainLayout openCart={openCart}>
                <MenRunning />
              </MainLayout>
            }
          />
          <Route
            path="/menindia"
            element={
              <MainLayout openCart={openCart}>
                <MenIndiaMerchandise />
              </MainLayout>
            }
          />
          <Route
            path="/menshopoutlet"
            element={
              <MainLayout openCart={openCart}>
                <MenShopOutlet />
              </MainLayout>
            }
          />
          <Route
            path="/menbag"
            element={
              <MainLayout openCart={openCart}>
                <MenBagsDuffels />
              </MainLayout>
            }
          />
          <Route
            path="/menhatcap"
            element={
              <MainLayout openCart={openCart}>
                <MenHatCap />
              </MainLayout>
            }
          />
          <Route
            path="/mensocks"
            element={
              <MainLayout openCart={openCart}>
                <MenSocks />
              </MainLayout>
            }
          />
          <Route
            path="/mensupporter"
            element={
              <MainLayout openCart={openCart}>
                <MenSupporter />
              </MainLayout>
            }
          />
          <Route
            path="/mencompressions"
            element={
              <MainLayout openCart={openCart}>
                <MenBaselayers />
              </MainLayout>
            }
          />
          <Route
            path="/menshoes"
            element={
              <MainLayout openCart={openCart}>
                <MenShoes />
              </MainLayout>
            }
          />
          {/*WOMEN SECTION NAVBAR*/}
          <Route
            path="/women"
            element={
              <MainLayout openCart={openCart}>
                <Women />
              </MainLayout>
            }
          />
          <Route
            path="/womentop"
            element={
              <MainLayout openCart={openCart}>
                <Womentop />
              </MainLayout>
            }
          />
          <Route
            path="/womenpolo"
            element={
              <MainLayout openCart={openCart}>
                <WomenPolo />
              </MainLayout>
            }
          />
          <Route
            path="/womensleevless"
            element={
              <MainLayout openCart={openCart}>
                <WomenSleeveless />
              </MainLayout>
            }
          />
          <Route
            path="/womenlongsleeves"
            element={
              <MainLayout openCart={openCart}>
                <WomenLongSleeve />
              </MainLayout>
            }
          />
          <Route
            path="/womenjackethoodies"
            element={
              <MainLayout openCart={openCart}>
                <WomenJacketHoodies />
              </MainLayout>
            }
          />
          <Route
            path="/womenshorts&skirts"
            element={
              <MainLayout openCart={openCart}>
                <WomenShortsSkirts />
              </MainLayout>
            }
          />
          <Route
            path="/womenpants&leggings"
            element={
              <MainLayout openCart={openCart}>
                <WomenPantsLeggines />
              </MainLayout>
            }
          />
          <Route
            path="/womentracksuit"
            element={
              <MainLayout openCart={openCart}>
                <WomenTracksuits />
              </MainLayout>
            }
          />
          <Route
            path="/womenshooting"
            element={
              <MainLayout openCart={openCart}>
                <WomenShooting />
              </MainLayout>
            }
          />
          <Route
            path="/womentraining"
            element={
              <MainLayout openCart={openCart}>
                <WomenTraining />
              </MainLayout>
            }
          />
          <Route
            path="/womenrunning"
            element={
              <MainLayout openCart={openCart}>
                <WomenRunning />
              </MainLayout>
            }
          />
          <Route
            path="/womenindiamerchandise"
            element={
              <MainLayout openCart={openCart}>
                <WomenIndiaMerchandise />
              </MainLayout>
            }
          />
          <Route
            path="/womenshopoutlets"
            element={
              <MainLayout openCart={openCart}>
                <WomenShopOutlets />
              </MainLayout>
            }
          />
          <Route
            path="/womenbagduffels"
            element={
              <MainLayout openCart={openCart}>
                <WomenBag />
              </MainLayout>
            }
          />
          {/*Cricket section*/}
          <Route
            path="/cricket"
            element={
              <MainLayout openCart={openCart}>
                <Cricket />
              </MainLayout>
            }
          />
          <Route
            path="/crickethelmets"
            element={
              <MainLayout openCart={openCart}>
                <CricketHelmets />
              </MainLayout>
            }
          />
          <Route
            path="/clothing"
            element={
              <MainLayout openCart={openCart}>
                <Clothing />
              </MainLayout>
            }
          />
          <Route
            path="/cricketball"
            element={
              <MainLayout openCart={openCart}>
                <CricketBall />
              </MainLayout>
            }
          />
          <Route
            path="/bag&duffles"
            element={
              <MainLayout openCart={openCart}>
                <BagDuffles />
              </MainLayout>
            }
          />
          <Route
            path="/accessories"
            element={
              <MainLayout openCart={openCart}>
                <Accessories />
              </MainLayout>
            }
          />
          <Route
            path="/shoes"
            element={
              <MainLayout openCart={openCart}>
                <Shoes />
              </MainLayout>
            }
          />
          <Route
            path="/shopoutlet"
            element={
              <MainLayout openCart={openCart}>
                <ShopOutlets />
              </MainLayout>
            }
          />
          {/*accessories section*/}
          <Route
            path="/accessories"
            element={
              <MainLayout openCart={openCart}>
                <AAccessories />
              </MainLayout>
            }
          />
          <Route
            path="/bags&duffles"
            element={
              <MainLayout openCart={openCart}>
                <BagsDuffles />
              </MainLayout>
            }
          />
          <Route
            path="/hats&caps"
            element={
              <MainLayout openCart={openCart}>
                <HatCap />
              </MainLayout>
            }
          />
          <Route
            path="/socks"
            element={
              <MainLayout openCart={openCart}>
                <Socks />
              </MainLayout>
            }
          />
          <Route
            path="/supporters"
            element={
              <MainLayout openCart={openCart}>
                <Supporter />
              </MainLayout>
            }
          />
          <Route
            path="/baselayers"
            element={
              <MainLayout openCart={openCart}>
                <Baselayers />
              </MainLayout>
            }
          />
          <Route
            path="/accessoriesshoes"
            element={
              <MainLayout openCart={openCart}>
                <AccessoriesShoes />
              </MainLayout>
            }
          />
          <Route
            path="/foamrollers"
            element={
              <MainLayout openCart={openCart}>
                <FormRollers />
              </MainLayout>
            }
          />
          <Route
            path="/loopbands"
            element={
              <MainLayout openCart={openCart}>
                <LoopBands />
              </MainLayout>
            }
          />
          <Route
            path="/accessoriesshopoutlets"
            element={
              <MainLayout openCart={openCart}>
                <AccessoriesShopOutlets />
              </MainLayout>
            }
          />

          {/*PAYMENT PATH PAYU */}
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/failure" element={<PaymentFailure />} />

          {/*Customer  */}
          <Route
            path="/userdashboard"
            element={
              <MainLayout openCart={openCart}>
                {" "}
                <CustomerDashboard />{" "}
              </MainLayout>
            }
          />
          <Route
            path="/userprofile"
            element={
              <MainLayout openCart={openCart}>
                <UserProfile />
              </MainLayout>
            }
          />
          <Route
            path="/userorder"
            element={
              <MainLayout openCart={openCart}>
                <OrdersPage />
              </MainLayout>
            }
          />

          {/* kit builder */}

          <Route
            path="/design-your-own"
            element={
              <MainLayout>
                <KitBuilder />
              </MainLayout>
            }
          />

          {/* Blog  */}
          {/* <Route path="/site-blogs/:slug" element={<BlogDetail />} /> */}
          <Route
            path="/blogs/:slug"
            element={
              <MainLayout openCart={openCart}>
                <BlogDetail />
              </MainLayout>
            }
          />
          <Route
            path="/blogs"
            element={
              <MainLayout openCart={openCart}>
                <BlogPage />
              </MainLayout>
            }
          />
          {/* New Arrival */}
          <Route
            path="/newarrival"
            element={
              <MainLayout openCart={openCart}>
                <NewArrivals />
              </MainLayout>
            }
          />
          {/* size chart */}
          <Route
            path="/sizechart"
            element={
              <MainLayout openCart={openCart}>
                <SizeChart />
              </MainLayout>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
